import { ArticleRequest, Label } from '../../api/queries';

export function buildPublishPayload(
  article: ArticleRequest,
  selectedLabels: Label[],
  coverImageUrl: string,
) {
  return {
    article: {
      ...article,
      coverImageAlt: article.coverImageAlt ?? '',
      coverImageUrl,
      draftId: article.draftId,
      labels: selectedLabels,
      isDraft: false,
    },
  };
}
